export default [
  {
    "x": 70.3238471,
    "y": 1.43292341,
    "angle": 2.9386497878368196,
    "lengthA": 16.305284709546484,
    "lengthB": 16.30528461159872
  },
  {
    "x": 80.2335526,
    "y": 12.7378641,
    "angle": -0.6845920395517564,
    "lengthA": 11.050365152559424,
    "lengthB": 11.050365120941573
  },
  {
    "x": 41.6875,
    "y": 42.5631068,
    "angle": -0.863775410482748,
    "lengthA": 20.57385621374052,
    "lengthB": 15.603145300018225
  },
  {
    "x": 48.1029946,
    "y": 89.6437973,
    "angle": 2.862055707526987,
    "lengthA": 27.295267533671513,
    "lengthB": 14.708245286046074
  },
  {
    "x": 86.3030469,
    "y": 97.5629103,
    "angle": -2.316722404518354,
    "lengthA": 11.441001768039158,
    "lengthB": 18.47048823593776
  },
  {
    "x": 82.6809211,
    "y": 149.281553,
    "angle": -0.7049834112032205,
    "lengthA": 18.957319745835154,
    "lengthB": 18.95732047001858
  },
  {
    "x": 17.5197368,
    "y": 141.980583,
    "angle": 0.8406333019013524,
    "lengthA": 28.771353570391398,
    "lengthB": 28.77135426876769
  },
  {
    "x": 1.84156198,
    "y": 73.6542508,
    "angle": 1.6882658773848533,
    "lengthA": 17.378626745542086,
    "lengthB": 35.80972169779646
  }
]